var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[(!_vm.ie)?_c('ysvedio',{ref:"netplay",attrs:{"showright":_vm.showRight,"playdata":_vm.playdata,"unshowaction":_vm.unshowaction}}):_c('netpay',{ref:"netieplay",attrs:{"data":_vm.playdata,"showright":_vm.showRight,"unshowaction":_vm.unshowaction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }